import {atom} from 'jotai'
import {
  ReferralCampaignProductList,
  ReferralCampaignProductListAll,
  ReferralCampaignProductListAllItem,
} from '../domain'

const referralCampaignProductList: ReferralCampaignProductList = {
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 100,
    totalCount: 0,
  },
  data: [],
  result: {
    customerMessage: null,
    errorCode: null,
    errorMessage: null,
    isSuccess: true,
  },
}

const referralCampaignProductListAll: ReferralCampaignProductListAll = {
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
  data: [],
  result: {
    customerMessage: null,
    errorCode: null,
    errorMessage: null,
    isSuccess: true,
  },
}

export const typeAtom = atom<string>('')

export const ReferralCampaignProductListAtom = atom<ReferralCampaignProductList>(
  referralCampaignProductList
)
export const referralCampaignProductListAllAtom = atom<ReferralCampaignProductListAll>(
  referralCampaignProductListAll
)

export const selectedGiveAwayProductAtom = atom<ReferralCampaignProductListAllItem[]>([])
export const selectedCampaignProductAtom = atom<ReferralCampaignProductListAllItem[]>([])

export const uploadType = atom<'products' | 'exclude' | null>(null)

export const campaignFiles = atom<{id: string; name: string; type?: number}[]>([])
export const uploadFileIds = atom<{id: string; name: string; type?: number}[]>([])
export const uploadProducts = atom<
  {id: string; code: string; name: string; category: string; createdOn: string; type?: number}[]
>([])

export const deleteFileIds = atom<string[]>([])
